/**
 * Main Reducer Declaration for Feed API
 *
 * @author Creator-Solutions -> Owen Burns
 */

import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import Feed from "@/redux/slices/thunk/feed";
import {
  FeedResponseState,
  GetFeedInterface,
  GetFeedResponseState,
  GetFeedState,
} from "@/interfaces/services/feed";

interface State {
  isLoading: boolean;
  isSuccessful: boolean;
  isError: boolean;
  message: string;
  feed: Array<GetFeedState>;
}

let initialState: State = {
  isLoading: false,
  isSuccessful: false,
  isError: false,
  message: "",
  feed: [],
};

const feedSlice = createSlice({
  name: "feed",
  initialState,
  reducers: {
    resetFeedArray(state) {
      state.isLoading = false;
      state.isError = false;
      state.isSuccessful = false;
      state.message = "";
      state.feed = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(Feed.getFeedThunk.pending, (state: State) => {
      state.isLoading = true;
    });
    builder.addCase(
      Feed.getFeedThunk.fulfilled,
      (state: State, action: PayloadAction<any, any>) => {
        if (!action.payload.feedResponse.isError) {
          state.isLoading = false;
          state.isError = false;
          state.isSuccessful = true;
          state.feed = action.payload.feedResponse[0].feed;
        }
      }
    );
    builder.addCase(Feed.getFeedThunk.rejected, (state: State) => {
      state.isError = true;
      state.isLoading = false;
      state.isSuccessful = false;
      state.message = "Could not complete the request";
    });
  },
});

export const { resetFeedArray } = feedSlice.actions;
export default feedSlice.reducer;
